export const normalizeCarat = (carat: number): number =>
    Math.round(carat * 100) / 100

/** Maps API codes such as `Diamond_F` to filter/display values like `F`. */
export const normalizeUnifiedPdpColourCode = (code: string): string => {
    const diamondMatch = code.match(/^Diamond_([A-Z])$/i)
    const colour = diamondMatch?.[1]

    if (colour) {
        return colour.toUpperCase()
    }

    return code
}

/** Maps API clarity codes to short labels such as `VS1`, `VVS2`. */
export const normalizeUnifiedPdpClarityCode = (code: string): string => {
    const clarityMatch = code.match(/^Clarity_(.+)$/i)
    const clarity = clarityMatch?.[1]

    if (clarity) {
        return clarity.toUpperCase()
    }

    return code
}

export const formatColourFilterLabel = (code: string): string =>
    normalizeUnifiedPdpColourCode(code)

export const formatClarityFilterLabel = (code: string): string =>
    normalizeUnifiedPdpClarityCode(code)

export const formatCaratFilterLabel = (carat: number): string => {
    const normalized = normalizeCarat(carat)
    const formatted = normalized.toFixed(2).replace(/\.?0+$/, '')

    if (normalized < 1) {
        return `${normalized.toFixed(2)}ct`
    }

    if (Number.isInteger(normalized)) {
        return `${normalized}ct`
    }

    return `${formatted}ct`
}
